import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import React from 'react';
import Card from './CardElement';

const StripeElementsProvider = (props) => {
const stripePromise = loadStripe(props.publishableKey);
    return (
        <Elements stripe={stripePromise}>
            <Card
              setupIntentClientSecret={props.setupIntentClientSecret}
              setCardverified={(status) => props.setCardverified(status)} 
              showCardVerified={props.showCardVerified}
              setError={(error) => props.setError(error)}
              cardverified={props.cardverified}
              setLoader={bool => props.showLoader(bool)}
              confirmationNumber={props.confirmationNumber}
              firstName={props.firstName}
              lastName={props.lastName}
              showFailScreen={(status, message) => props.showFailScreen(status, message)} 
              setcardVerified={(status, token) => props.setcardVerified(status, token)}
              iscardVerified={props.iscardVerified}
              countryOptions={props.countryOptions}
              guestBookFormData={props.guestBookFormData}
              next={props.next}
              goBack={props.goBack}
              canSkipCardValidation={props.canSkipCardValidation}
            />
        </Elements>
    );
};

export default StripeElementsProvider;